import PropTypes from 'prop-types';
import LcResourcesArticles from '../lcResourcesArticles/lcResourcesArticles';
import styles from './lcResources.module.scss';

export default function LcResources({ title = null, lcResources = [] }) {
  return (
    <div className={styles.lcResources}>
      <div className={styles.title}>
        <h3>{title}</h3>
      </div>
      <div className={styles.articles}>
        {lcResources.map((resource) => (
          <LcResourcesArticles key={resource.title} {...resource} />
        ))}
      </div>
    </div>
  );
}

LcResources.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
};
